import {autoserialize} from 'cerialize';

export default class Newsletter {
    @autoserialize public subject: string;
    @autoserialize public message: string;
    @autoserialize public client_ids: number[];

    constructor(subject: string, message: string, client_ids: number[]) {
        this.subject = subject;
        this.message = message;
        this.client_ids = client_ids;
    }
}